export default __webpack_public_path__ + "static/media/howworks3.d7b3d9c7.png";